import LeaderboardCampaignInfo from '~/javascripts/components/Team/Campaign/LeaderboardCampaignInfo';
import LeaderboardUserInfo from '~/javascripts/components/LifetimeImpact/LeaderboardUserInfo';
import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';

const InfiniteScroll = observer(
  ({ column, dataUrl, infiniteScrollContainer, resourceId, resourceType }) => {
    const infiniteScrollContainerEl = useRef(null);
    const triggerLoadEl = useRef(null);
    let currentPage = 1;

    const [data, setData] = useState({});

    useEffect(() => {
      if (store.team.refreshLeaderboard) {
        currentPage = 1;
        fetchPage(true);
        store.team.refreshLeaderboard = false;
      }
    }, [store.team.refreshLeaderboard]);

    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            fetchPage();
          }
        },
        { root: infiniteScrollContainerEl.current }
      );

      observer.observe(triggerLoadEl.current);

      return () => {
        observer.disconnect();
      };
    }, []);

    const fetchPage = (clearData = false) => {
      $.get(
        `${dataUrl}?page=${currentPage}${
          resourceId ? `&id=${resourceId}` : ''
        }${column ? `&column=${column}` : ''}`,
        (response) => {
          if (response) {
            setData((data) => {
              const baseData = clearData ? {} : data;
              return Object.assign({}, baseData, response.data);
            });
            currentPage++;
          }
        }
      );
    };

    return (
      <div
        className={`${infiniteScrollContainer} px-1 pb-1 overflow-y-auto`}
        id={infiniteScrollContainer}
        ref={infiniteScrollContainerEl}
      >
        <div className='infinite-container mt-1 p-0'>
          {resourceType == 'profileCampaign'
            ? Object.entries(data).map(([slug, campaign], index) => (
                /* eslint-disable react/jsx-indent */
                <LeaderboardCampaignInfo
                  campaign={campaign}
                  column={column}
                  index={index}
                  key={slug}
                />
              ))
            : Object.entries(data).map(([slug, user]) => (
                /* eslint-disable react/jsx-indent */
                <LeaderboardUserInfo key={slug} user={user} />
              ))}
        </div>
        <div ref={triggerLoadEl} />
      </div>
    );
  }
);

export default InfiniteScroll;
